/* RH Now Build 13: accessible manual merchandise carousels (no autoplay) */
(function () {
  function initialize() {
    document.querySelectorAll('[data-rh-merch-slider]').forEach(function (root) {
      if (root.dataset.rhSliderReady === '1') return;
      var track = root.querySelector('[data-rh-merch-track]');
      var prev = root.querySelector('[data-rh-merch-prev]');
      var next = root.querySelector('[data-rh-merch-next]');
      var count = root.querySelector('[data-rh-merch-count]');
      if (!track || !prev || !next) return;
      root.dataset.rhSliderReady = '1';
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function step() {
        var first = track.firstElementChild;
        if (!first) return 0;
        var styles = window.getComputedStyle(track);
        return first.getBoundingClientRect().width + (parseFloat(styles.columnGap) || 0);
      }
      function update() {
        var max = Math.max(0, track.scrollWidth - track.clientWidth);
        prev.disabled = track.scrollLeft <= 3;
        next.disabled = track.scrollLeft >= max - 3;
        if (count) {
          var total = track.children.length;
          var current = Math.max(1, Math.min(total, Math.round(track.scrollLeft / Math.max(step(), 1)) + 1));
          count.textContent = current + ' / ' + total;
        }
      }
      prev.addEventListener('click', function () {
        track.scrollBy({left: -step(), behavior: reduce ? 'auto' : 'smooth'});
      });
      next.addEventListener('click', function () {
        track.scrollBy({left: step(), behavior: reduce ? 'auto' : 'smooth'});
      });
      track.addEventListener('scroll', update, {passive:true});
      window.addEventListener('resize', update, {passive:true});
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();